__turbopack_context__.v({
  "className": "cormorant_garamond_9121b3ca-module__Eh25sG__className",
  "variable": "cormorant_garamond_9121b3ca-module__Eh25sG__variable",
});
